import './FormActionVariable.css';
import VariableBlock from './VariableBlock/VariableBlock';
import { useState } from 'react';
import TitleBlock from '../TitleBlock/TitleBlock';
import AreaList from '../UI/AreaList/AreaList';
import AreaListData from '../UI/AreaListData/AreaListData';
import { useForm } from 'react-hook-form';
import editorAction from '../../../actions/editorAction';
import { useTreeStateContext } from '../../../contexts/TreeContext';
import binarySearchString from '../../../utils/binarySearchString';
import { BlockActionVariableDefault } from '../../../data/constant/blocks/BlockActionVariableDefault';
import useErrorCheckEditor from '../../../hook/useErrorCheckEditor';
import { useTreeDispatchContext } from '../../../contexts/TreeContext';
function FormActionVariable({ id }) {

    const { blocks, paths } = useTreeStateContext();
    const dispatch = useTreeDispatchContext();
    const indexBlock = binarySearchString(blocks, id, 'object_id');
    const block = blocks[indexBlock] ?  blocks[indexBlock] : BlockActionVariableDefault
    const { data } = block;
    const name = block.name;

    const { checkErrorBlock } = useErrorCheckEditor()

   
    const variables = data.variables;
    const { updateBlockData } = editorAction();

    const setValueForm = (index, name, value) => {
        setValue(`variables.${index}.${name}`, value);
        onSubmit(getValues());
    }

    const addNewVariable = (scroll) => {
        const length = variables.length;
        const variable = { value : "", is_operation : 0,index : length.toString(), variable : null, isOpen : true }
        setValue(`variables.${length}`, variable)
        onSubmit(getValues());
        scroll()
    }

    const deleteVariable = (index) => {
        var data = getValues('variables');
        data = Object.values(data).filter(variable => variable.index !== index ).map((variable,idx) => { return {...variable, index : idx.toString()}});
        setValue('variables', data);
        onSubmit(getValues());
    }

    const moveVariable = (indexStart, indexDestination) => { 
        var data = getValues('variables');      
        [data[indexStart], data[indexDestination]] = [data[indexDestination], data[indexStart]] // swapping element
        data = Object.values(data).map((variable,idx) => { return {...variable, index : idx.toString()}});
        setValue('variables', data);
        onSubmit(getValues());
    }

    const errors = checkErrorBlock(block, { blocks, paths });
    var errorRaw = Object.entries(errors).filter( ([key, value]) => value.type == 'Wrong Spelling')

    const setValueState = (index, name, value) => {
        setValue(`variables.${index}.${name}`, value);
        const data = getValues();
        dispatch({type : 'updateBlockData', payload : { id, data }})
    }

    const functionVariable = {
        setValueState : setValueState,
        setValue : setValueForm,
        deleteValue : deleteVariable,
        move : moveVariable,
        errors : errorRaw
    }

    const { getValues, setValue } = useForm({
		mode: "onBlur",
		defaultValues: { variables : variables }
	});

    const transformBlockName = (data) => {
        if(data.variables[0].variable == null || /variable/.test(name) == false ) return data
        data.name = `Set variable [${data.variables[0].variable.name.toUpperCase()}]`
        console.log(data)
        return data
    }

    const onSubmit = (data) => {

        data = transformBlockName(data);
        const dataServer = {
            variables : data.variables.map( (variable, index) => { 
                return {
                    variable_value : variable.value, 
                    is_operation : variable.is_operation,
                    index : variable.index.toString(),
                    variable_name : variable.variable == null ? null : variable.variable.name , 
            }})
        }

        if(data.name) {
            dataServer.name = data.name
        }

        updateBlockData(id, data, dataServer)
    }

    return (
        <>
            <TitleBlock title="Set Variables" titleInput="Variables name" name={name} id={id}/>
            <AreaList title="Variables" maxHeight="550px" onClickButton={(func) => addNewVariable(...func)} buttonLabel="Add a Variable">
                <AreaListData data={variables} ComponentRow={VariableBlock} FunctionsRow={functionVariable}></AreaListData>
            </AreaList>

        </>
    )
}

export default FormActionVariable;